import { Controller } from "stimulus"
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["groupSelect", "jurySelect"]

  static values = { url: String }

  connect() {
    setTimeout(() => {
      this.groupSelectTarget.addEventListener("change", this.loadJuries.bind(this));
    }, 100);
  }

  loadJuries() {
    const groupSynched = this.groupSelectTarget.value;
    
    if (!groupSynched) {
      this.clearJuryOptions();
      return;
    }

    Rails.ajax({
      url: `${this.urlValue}?group_synched=${groupSynched}`,
      type: "get",
      success: ((data) => this.onLoad(data))
    });
  }

  onLoad(data) {
    this.jurySelectTarget.choices.clearStore();
    
    const formattedData = data.map(e => { 
      return { 'value': e.value, 'label': e.label, 'selected': false } 
    });
    
    this.jurySelectTarget.choices.setChoices(formattedData, 'value', 'label', true);
  }

  clearJuryOptions() {
    this.jurySelectTarget.choices.clearStore();
  }
} 